import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import templateService from "../../../services/template.service";
import { toast } from "react-toastify";
import VoiceSequence from "./VoiceSequence";
function AddCallTemplate() {
  const [templateTypes, setTemplateTypes] = useState([]);
  const navigate = useNavigate();
  const [txtContent, setTxtContent] = useState(null);
  const [txtVoiceSequence, setTxtVoiceSequence] = useState([]);
  const [txtUsedBy, settxtUsedBy] = useState("CLINIC");
  const [newItem, setNewItem] = useState({
    type: "Static",
    content: "",
    path: null,
  });
  const [txtType, setTxtType] = useState(null);
  useEffect(() => {
    //check if templateid contains ecx or cli in first 3 characters
    getTemplateTypes();
  }, []);

  const getTemplateTypes = () => {
    templateService
      .getTemplateTypes()
      .then((res) => {
        setTemplateTypes(res.data);
        setTxtType(res.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handletxtTypeChange = (event) => {
    setTxtType(event.target.value);
  };
  const handletxtUsedByChange = (event) => {
    settxtUsedBy(event.target.value);
  };
  const handleTextAreaChange = (event) => {
    setTxtContent(event.target.value);
  };
  const handleUpdateVS = (index, updatedVS) => {
    // console.log("handle update ",index,updatedVS)
    const updatedVoiceSquence = [...txtVoiceSequence];
    // console.log(updatedVoiceSquence)
    updatedVoiceSquence[index] = updatedVS;
    //console.log("Updated")

    setTxtVoiceSequence(updatedVoiceSquence);
  };
  const handleDeleteVS = (index) => {
    const updatedVoiceSequence = txtVoiceSequence.filter((_, i) => i !== index);
    setTxtVoiceSequence(updatedVoiceSequence);
  };
  const handleAddVS = () => {
    setTxtVoiceSequence([...txtVoiceSequence, newItem]);
    setNewItem({ type: "Static", content: "", path: null });
  };
  const handleAdd = () => {
    //things needed
    //type , mediumType="SMS", subjectLine=null, content, usedBy,voiceSequence=null
    const data = {
      type: txtType,
      mediumType: "CALL",
      //  "subjectLine" : null,
      content: txtContent,
      usedBy: txtUsedBy,
      voiceSequence: null,
    };
    templateService
      .saveEcxTemplate(1, data)
      .then((res) => {
        toast.success("Successfully Added New Template.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        navigate("/telephone-template");
      })
      .catch((err) => {
        toast.error("Cannot Create New Template.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        console.log(err);
      });
  };

  const handleCancel = () => {
    navigate("/telephone-template");
  };

  return (
    <>
      <div className="container container-xxl">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Eyeconx Telephone Template</h5>

            <div className="row">
              <div className="col-10">
                <div className="form-group">
                  <label className="form-label" htmlFor="">
                    Type
                  </label>
                  <select
                    name="smsType"
                    id="smsType"
                    onChange={handletxtTypeChange}
                    className="form-select form-select-sm"
                  >
                    {templateTypes &&
                      templateTypes.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="form-group mt-2">
                  <label className="form-label" htmlFor="">
                    Used By
                  </label>
                  <select
                    name="usedBy"
                    id="usedBy"
                    onChange={handletxtUsedByChange}
                    className="form-select form-select-sm"
                  >
                    <option value="CLINIC">Clinic</option>
                    <option value="ECX">EyeconX</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    Content
                  </label>
                  <textarea
                    name=""
                    id=""
                    rows="5"
                    className="form-control"
                    value={txtContent}
                    onChange={handleTextAreaChange}
                  ></textarea>
                </div>
                <div className="mt-2">
                  <span className="text-danger">
                    Note: Edit Voice Sequence after creating the template.
                  </span>
                </div>

                <div className="d-flex justify-content-between mt-3"></div>
              </div>
              <div className="col-2">
                <div className="d-flex flex-column">
                  <button
                    className="btn btn-primary btn-sm mb-2"
                    onClick={handleAdd}
                  >
                    <i className="bi bi-floppy2"></i> Add New Template
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={handleCancel}
                  >
                    <i className="bi bi-x-square"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddCallTemplate;
